// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"1bb2866e1224027b1996","966":"bc3b03b9fa985d63e866"}[chunkId] + ".js";
};